// extracted by mini-css-extract-plugin
export default {"active":"__profile_active__nVFm-","tableResponsive":"__profile_tableResponsive__nVFm-"};